import { makeGraphQLRequest, makeGraphQLPaginatedRequest } from 'graphql/makeGraphQLRequest';
import { GET_SIMPLR_EXPERT_BY_ID_QUERY, GET_NOMINATED_EXPERT_QUEUES_QUERY, FIND_ALL_EXPERTS_QUERY } from './expert.gql';
import { CONVERSATION_QUERY_LIMIT } from 'constants/limits';
import { getExpertId } from 'util/parseSelectors';
import escapeRegExp from 'lodash/escapeRegExp';
import { processSimplrExpert } from 'util/dataObjectToStoreObject';

export const getExpertById = async (id) => {
  const simplrExpert = await makeGraphQLRequest(
    GET_SIMPLR_EXPERT_BY_ID_QUERY,
    { simplrExpertId: id },
    'simplrExpertGet'
  );

  return simplrExpert;
};

export const getNominatedExpertQueues = async () => {
  const { data: expertQueues } = await makeGraphQLPaginatedRequest(
    GET_NOMINATED_EXPERT_QUEUES_QUERY,
    {
      sorting: [
        {
          direction: 'ASC',
          field: 'messageArrivedAt',
        },
      ],
      filter: {
        simplrExpertId: {
          eq: getExpertId(),
        },
        isActive: {
          is: true,
        },
      },
      paging: {
        first: CONVERSATION_QUERY_LIMIT,
      },
    },
    'expertQueuesFind'
  );

  return expertQueues || [];
};

export const getExperts = async (params) => {
  const {
    limit = 20,
    email,
    firstName,
    lastName,
    searchParam,
    availabilityState,
    isActive,
    isSpecialist,
    cursor,
  } = params;

  const filter = {
    isDeleted: {
      is: false,
    },
  };

  const sorting = [
    {
      direction: 'ASC',
      field: 'firstName',
    },
  ];

  const paging = {
    first: limit,
    after: cursor,
  };

  if (searchParam) {
    // eslint-disable-next-line no-useless-escape
    const matcher = `${searchParam.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')}%`;
    filter.or = [
      {
        firstName: {
          iLike: matcher,
        },
      },
      {
        lastName: {
          iLike: matcher,
        },
      },
    ];
  }

  if (isActive) {
    filter.isActive = {
      is: isActive,
    };
  }

  if (isSpecialist) {
    filter.isSpecialist = {
      is: isSpecialist,
    };
  }

  if (email) {
    filter.email = {
      iLike: escapeRegExp(email),
    };
  }

  if (firstName) {
    filter.firstName = {
      iLike: `${firstName}%`,
    };
  }

  if (lastName) {
    filter.lastName = {
      iLike: `${lastName}%`,
    };
  }

  if (availabilityState) {
    filter.availability = {
      eq: availabilityState,
    };
  }

  const { data: experts, pageInfo } = await makeGraphQLPaginatedRequest(
    FIND_ALL_EXPERTS_QUERY,
    {
      paging,
      sorting,
      filter,
    },
    'simplrExpertsFind'
  );

  return {
    experts: (experts || []).filter((e) => e.userId && e.simplrAccountId).map(processSimplrExpert),
    cursor: pageInfo.cursor,
  };
};
